import * as countryFlags from 'country-flag-icons/react/3x2'

const countryList = [
  { value: 'af', label: 'Afghanistan', icon: <countryFlags.AF /> },
  { value: 'al', label: 'Albania', icon: <countryFlags.AL /> },
  { value: 'dz', label: 'Algeria', icon: <countryFlags.DZ /> },
  { value: 'as', label: 'American Samoa', icon: <countryFlags.AS /> },
  { value: 'ad', label: 'Andorra', icon: <countryFlags.AD /> },
  { value: 'ao', label: 'Angola', icon: <countryFlags.AO /> },
  { value: 'ai', label: 'Anguilla', icon: <countryFlags.AI /> },
  { value: 'aq', label: 'Antarctica', icon: <countryFlags.AQ /> },
  { value: 'ag', label: 'Antigua and Barbuda', icon: <countryFlags.AG /> },
  { value: 'ar', label: 'Argentina', icon: <countryFlags.AR /> },
  { value: 'am', label: 'Armenia', icon: <countryFlags.AM /> },
  { value: 'aw', label: 'Aruba', icon: <countryFlags.AW /> },
  { value: 'au', label: 'Australia', icon: <countryFlags.AU /> },
  { value: 'at', label: 'Austria', icon: <countryFlags.AT /> },
  { value: 'az', label: 'Azerbaijan', icon: <countryFlags.AZ /> },
  { value: 'bs', label: 'Bahamas', icon: <countryFlags.BS /> },
  { value: 'bh', label: 'Bahrain', icon: <countryFlags.BH /> },
  { value: 'bd', label: 'Bangladesh', icon: <countryFlags.BD /> },
  { value: 'bb', label: 'Barbados', icon: <countryFlags.BB /> },
  { value: 'by', label: 'Belarus', icon: <countryFlags.BY /> },
  { value: 'be', label: 'Belgium', icon: <countryFlags.BE /> },
  { value: 'bz', label: 'Belize', icon: <countryFlags.BZ /> },
  { value: 'bj', label: 'Benin', icon: <countryFlags.BJ /> },
  { value: 'bm', label: 'Bermuda', icon: <countryFlags.BM /> },
  { value: 'bt', label: 'Bhutan', icon: <countryFlags.BT /> },
  {
    value: 'bo',
    label: 'Bolivia',
    icon: <countryFlags.BO />,
  },
  {
    value: 'bq',
    label: 'Bonaire, Sint Eustatius and Saba',
    icon: <countryFlags.BQ />,
  },
  { value: 'ba', label: 'Bosnia and Herzegovina', icon: <countryFlags.BA /> },
  { value: 'bw', label: 'Botswana', icon: <countryFlags.BW /> },
  { value: 'bv', label: 'Bouvet Island', icon: <countryFlags.BV /> },
  { value: 'br', label: 'Brazil', icon: <countryFlags.BR /> },
  {
    value: 'io',
    label: 'British Indian Ocean Territory',
    icon: <countryFlags.IO />,
  },
  { value: 'bn', label: 'Brunei Darussalam', icon: <countryFlags.BN /> },
  { value: 'bg', label: 'Bulgaria', icon: <countryFlags.BG /> },
  { value: 'bf', label: 'Burkina Faso', icon: <countryFlags.BF /> },
  { value: 'bi', label: 'Burundi', icon: <countryFlags.BI /> },
  { value: 'cv', label: 'Cabo Verde', icon: <countryFlags.CV /> },
  { value: 'kh', label: 'Cambodia', icon: <countryFlags.KH /> },
  { value: 'cm', label: 'Cameroon', icon: <countryFlags.CM /> },
  { value: 'ca', label: 'Canada', icon: <countryFlags.CA /> },
  { value: 'ky', label: 'Cayman Islands', icon: <countryFlags.KY /> },
  {
    value: 'cf',
    label: 'Central African Republic',
    icon: <countryFlags.CF />,
  },
  { value: 'td', label: 'Chad', icon: <countryFlags.TD /> },
  { value: 'cl', label: 'Chile', icon: <countryFlags.CL /> },
  { value: 'cn', label: 'China', icon: <countryFlags.CN /> },
  { value: 'cx', label: 'Christmas Island', icon: <countryFlags.CX /> },
  {
    value: 'cc',
    label: 'Cocos Islands',
    icon: <countryFlags.CC />,
  },
  { value: 'co', label: 'Colombia', icon: <countryFlags.CO /> },
  { value: 'km', label: 'Comoros', icon: <countryFlags.KM /> },
  {
    value: 'cd',
    label: 'Democratic Republic of the Congo',
    icon: <countryFlags.CD />,
  },
  { value: 'cg', label: 'Congo', icon: <countryFlags.CG /> },
  { value: 'ck', label: 'Cook Islands', icon: <countryFlags.CK /> },
  { value: 'cr', label: 'Costa Rica', icon: <countryFlags.CR /> },
  { value: 'hr', label: 'Croatia', icon: <countryFlags.HR /> },
  { value: 'cu', label: 'Cuba', icon: <countryFlags.CU /> },
  { value: 'cw', label: 'Curaçao', icon: <countryFlags.CW /> },
  { value: 'cy', label: 'Cyprus', icon: <countryFlags.CY /> },
  { value: 'cz', label: 'Czechia', icon: <countryFlags.CZ /> },
  { value: 'ci', label: "Côte d'Ivoire", icon: <countryFlags.CI /> },
  { value: 'dk', label: 'Denmark', icon: <countryFlags.DK /> },
  { value: 'dj', label: 'Djibouti', icon: <countryFlags.DJ /> },
  { value: 'dm', label: 'Dominica', icon: <countryFlags.DM /> },
  {
    value: 'do',
    label: 'Dominican Republic',
    icon: <countryFlags.DO />,
  },
  { value: 'ec', label: 'Ecuador', icon: <countryFlags.EC /> },
  { value: 'eg', label: 'Egypt', icon: <countryFlags.EG /> },
  { value: 'sv', label: 'El Salvador', icon: <countryFlags.SV /> },
  { value: 'gq', label: 'Equatorial Guinea', icon: <countryFlags.GQ /> },
  { value: 'er', label: 'Eritrea', icon: <countryFlags.ER /> },
  { value: 'ee', label: 'Estonia', icon: <countryFlags.EE /> },
  { value: 'sz', label: 'Eswatini', icon: <countryFlags.SZ /> },
  { value: 'et', label: 'Ethiopia', icon: <countryFlags.ET /> },
  {
    value: 'fk',
    label: 'Falkland Islands [Malvinas]',
    icon: <countryFlags.FK />,
  },
  { value: 'fo', label: 'Faroe Islands', icon: <countryFlags.FO /> },
  { value: 'fj', label: 'Fiji', icon: <countryFlags.FJ /> },
  { value: 'fi', label: 'Finland', icon: <countryFlags.FI /> },
  { value: 'fr', label: 'France', icon: <countryFlags.FR /> },
  { value: 'gf', label: 'French Guiana', icon: <countryFlags.GF /> },
  { value: 'pf', label: 'French Polynesia', icon: <countryFlags.PF /> },
  {
    value: 'tf',
    label: 'French Southern Territories',
    icon: <countryFlags.TF />,
  },
  { value: 'ga', label: 'Gabon', icon: <countryFlags.GA /> },
  { value: 'gm', label: 'Gambia', icon: <countryFlags.GM /> },
  { value: 'ge', label: 'Georgia', icon: <countryFlags.GE /> },
  { value: 'de', label: 'Germany', icon: <countryFlags.DE /> },
  { value: 'gh', label: 'Ghana', icon: <countryFlags.GH /> },
  { value: 'gi', label: 'Gibraltar', icon: <countryFlags.GI /> },
  { value: 'gr', label: 'Greece', icon: <countryFlags.GR /> },
  { value: 'gl', label: 'Greenland', icon: <countryFlags.GL /> },
  { value: 'gd', label: 'Grenada', icon: <countryFlags.GD /> },
  { value: 'gp', label: 'Guadeloupe', icon: <countryFlags.GP /> },
  { value: 'gu', label: 'Guam', icon: <countryFlags.GU /> },
  { value: 'gt', label: 'Guatemala', icon: <countryFlags.GT /> },
  { value: 'gg', label: 'Guernsey', icon: <countryFlags.GG /> },
  { value: 'gn', label: 'Guinea', icon: <countryFlags.GN /> },
  { value: 'gw', label: 'Guinea-Bissau', icon: <countryFlags.GW /> },
  { value: 'gy', label: 'Guyana', icon: <countryFlags.GY /> },
  { value: 'ht', label: 'Haiti', icon: <countryFlags.HT /> },
  {
    value: 'hm',
    label: 'Heard Island and McDonald Islands',
    icon: <countryFlags.HM />,
  },
  { value: 'va', label: 'Holy See', icon: <countryFlags.VA /> },
  { value: 'hn', label: 'Honduras', icon: <countryFlags.HN /> },
  { value: 'hk', label: 'Hong Kong', icon: <countryFlags.HK /> },
  { value: 'hu', label: 'Hungary', icon: <countryFlags.HU /> },
  { value: 'is', label: 'Iceland', icon: <countryFlags.IS /> },
  { value: 'in', label: 'India', icon: <countryFlags.IN /> },
  { value: 'id', label: 'Indonesia', icon: <countryFlags.ID /> },
  {
    value: 'ir',
    label: 'Iran',
    icon: <countryFlags.IR />,
  },
  { value: 'iq', label: 'Iraq', icon: <countryFlags.IQ /> },
  { value: 'ie', label: 'Ireland', icon: <countryFlags.IE /> },
  { value: 'im', label: 'Isle of Man', icon: <countryFlags.IM /> },
  { value: 'il', label: 'Israel', icon: <countryFlags.IL /> },
  { value: 'it', label: 'Italy', icon: <countryFlags.IT /> },
  { value: 'jm', label: 'Jamaica', icon: <countryFlags.JM /> },
  { value: 'jp', label: 'Japan', icon: <countryFlags.JP /> },
  { value: 'je', label: 'Jersey', icon: <countryFlags.JE /> },
  { value: 'jo', label: 'Jordan', icon: <countryFlags.JO /> },
  { value: 'kz', label: 'Kazakhstan', icon: <countryFlags.KZ /> },
  { value: 'ke', label: 'Kenya', icon: <countryFlags.KE /> },
  { value: 'ki', label: 'Kiribati', icon: <countryFlags.KI /> },
  {
    value: 'kp',
    label: 'North Korea',
    icon: <countryFlags.KP />,
  },
  { value: 'kr', label: 'South Korea', icon: <countryFlags.KR /> },
  { value: 'kw', label: 'Kuwait', icon: <countryFlags.KW /> },
  { value: 'kg', label: 'Kyrgyzstan', icon: <countryFlags.KG /> },
  {
    value: 'la',
    label: "Lao People's Democratic Republic",
    icon: <countryFlags.LA />,
  },
  { value: 'lv', label: 'Latvia', icon: <countryFlags.LV /> },
  { value: 'lb', label: 'Lebanon', icon: <countryFlags.LB /> },
  { value: 'ls', label: 'Lesotho', icon: <countryFlags.LS /> },
  { value: 'lr', label: 'Liberia', icon: <countryFlags.LR /> },
  { value: 'ly', label: 'Libya', icon: <countryFlags.LY /> },
  { value: 'li', label: 'Liechtenstein', icon: <countryFlags.LI /> },
  { value: 'lt', label: 'Lithuania', icon: <countryFlags.LT /> },
  { value: 'lu', label: 'Luxembourg', icon: <countryFlags.LU /> },
  { value: 'mo', label: 'Macao', icon: <countryFlags.MO /> },
  { value: 'mg', label: 'Madagascar', icon: <countryFlags.MG /> },
  { value: 'mw', label: 'Malawi', icon: <countryFlags.MW /> },
  { value: 'my', label: 'Malaysia', icon: <countryFlags.MY /> },
  { value: 'mv', label: 'Maldives', icon: <countryFlags.MV /> },
  { value: 'ml', label: 'Mali', icon: <countryFlags.ML /> },
  { value: 'mt', label: 'Malta', icon: <countryFlags.MT /> },
  { value: 'mh', label: 'Marshall Islands', icon: <countryFlags.MH /> },
  { value: 'mq', label: 'Martinique', icon: <countryFlags.MQ /> },
  { value: 'mr', label: 'Mauritania', icon: <countryFlags.MR /> },
  { value: 'mu', label: 'Mauritius', icon: <countryFlags.MU /> },
  { value: 'yt', label: 'Mayotte', icon: <countryFlags.YT /> },
  { value: 'mx', label: 'Mexico', icon: <countryFlags.MX /> },
  {
    value: 'fm',
    label: 'Micronesia',
    icon: <countryFlags.FM />,
  },
  {
    value: 'md',
    label: 'Moldova',
    icon: <countryFlags.MD />,
  },
  { value: 'mc', label: 'Monaco', icon: <countryFlags.MC /> },
  { value: 'mn', label: 'Mongolia', icon: <countryFlags.MN /> },
  { value: 'me', label: 'Montenegro', icon: <countryFlags.ME /> },
  { value: 'ms', label: 'Montserrat', icon: <countryFlags.MS /> },
  { value: 'ma', label: 'Morocco', icon: <countryFlags.MA /> },
  { value: 'mz', label: 'Mozambique', icon: <countryFlags.MZ /> },
  { value: 'mm', label: 'Myanmar', icon: <countryFlags.MM /> },
  { value: 'na', label: 'Namibia', icon: <countryFlags.NA /> },
  { value: 'nr', label: 'Nauru', icon: <countryFlags.NR /> },
  { value: 'np', label: 'Nepal', icon: <countryFlags.NP /> },
  { value: 'nl', label: 'Netherlands', icon: <countryFlags.NL /> },
  { value: 'nc', label: 'New Caledonia', icon: <countryFlags.NC /> },
  { value: 'nz', label: 'New Zealand', icon: <countryFlags.NZ /> },
  { value: 'ni', label: 'Nicaragua', icon: <countryFlags.NI /> },
  { value: 'ne', label: 'Niger', icon: <countryFlags.NE /> },
  { value: 'ng', label: 'Nigeria', icon: <countryFlags.NG /> },
  { value: 'nu', label: 'Niue', icon: <countryFlags.NU /> },
  { value: 'nf', label: 'Norfolk Island', icon: <countryFlags.NF /> },
  {
    value: 'mp',
    label: 'Northern Mariana Islands',
    icon: <countryFlags.MP />,
  },
  { value: 'no', label: 'Norway', icon: <countryFlags.NO /> },
  { value: 'om', label: 'Oman', icon: <countryFlags.OM /> },
  { value: 'pk', label: 'Pakistan', icon: <countryFlags.PK /> },
  { value: 'pw', label: 'Palau', icon: <countryFlags.PW /> },
  { value: 'ps', label: 'Palestine, State of', icon: <countryFlags.PS /> },
  { value: 'pa', label: 'Panama', icon: <countryFlags.PA /> },
  { value: 'pg', label: 'Papua New Guinea', icon: <countryFlags.PG /> },
  { value: 'py', label: 'Paraguay', icon: <countryFlags.PY /> },
  { value: 'pe', label: 'Peru', icon: <countryFlags.PE /> },
  { value: 'ph', label: 'Philippines', icon: <countryFlags.PH /> },
  { value: 'pn', label: 'Pitcairn', icon: <countryFlags.PN /> },
  { value: 'pl', label: 'Poland', icon: <countryFlags.PL /> },
  { value: 'pt', label: 'Portugal', icon: <countryFlags.PT /> },
  { value: 'pr', label: 'Puerto Rico', icon: <countryFlags.PR /> },
  { value: 'qa', label: 'Qatar', icon: <countryFlags.QA /> },
  {
    value: 'mk',
    label: 'Republic of North Macedonia',
    icon: <countryFlags.MK />,
  },
  { value: 'ro', label: 'Romania', icon: <countryFlags.RO /> },
  {
    value: 'ru',
    label: 'Russia',
    icon: <countryFlags.RU />,
  },
  { value: 'rw', label: 'Rwanda', icon: <countryFlags.RW /> },
  { value: 're', label: 'Réunion', icon: <countryFlags.RE /> },
  { value: 'bl', label: 'Saint Barthélemy', icon: <countryFlags.BL /> },
  {
    value: 'sh',
    label: 'Saint Helena',
    icon: <countryFlags.SH />,
  },
  { value: 'kn', label: 'Saint Kitts and Nevis', icon: <countryFlags.KN /> },
  { value: 'lc', label: 'Saint Lucia', icon: <countryFlags.LC /> },
  {
    value: 'mf',
    label: 'Saint Martin',
    icon: <countryFlags.MF />,
  },
  {
    value: 'pm',
    label: 'Saint Pierre and Miquelon',
    icon: <countryFlags.PM />,
  },
  {
    value: 'vc',
    label: 'Saint Vincent and the Grenadines',
    icon: <countryFlags.VC />,
  },
  { value: 'ws', label: 'Samoa', icon: <countryFlags.WS /> },
  { value: 'sm', label: 'San Marino', icon: <countryFlags.SM /> },
  { value: 'st', label: 'Sao Tome and Principe', icon: <countryFlags.ST /> },
  { value: 'sa', label: 'Saudi Arabia', icon: <countryFlags.SA /> },
  { value: 'sn', label: 'Senegal', icon: <countryFlags.SN /> },
  { value: 'rs', label: 'Serbia', icon: <countryFlags.RS /> },
  { value: 'sc', label: 'Seychelles', icon: <countryFlags.SC /> },
  { value: 'sl', label: 'Sierra Leone', icon: <countryFlags.SL /> },
  { value: 'sg', label: 'Singapore', icon: <countryFlags.SG /> },
  {
    value: 'sx',
    label: 'Sint Maarten',
    icon: <countryFlags.SX />,
  },
  { value: 'sk', label: 'Slovakia', icon: <countryFlags.SK /> },
  { value: 'si', label: 'Slovenia', icon: <countryFlags.SI /> },
  { value: 'sb', label: 'Solomon Islands', icon: <countryFlags.SB /> },
  { value: 'so', label: 'Somalia', icon: <countryFlags.SO /> },
  { value: 'za', label: 'South Africa', icon: <countryFlags.ZA /> },
  {
    value: 'gs',
    label: 'South Georgia and the South Sandwich Islands',
    icon: <countryFlags.GS />,
  },
  { value: 'ss', label: 'South Sudan', icon: <countryFlags.SS /> },
  { value: 'es', label: 'Spain', icon: <countryFlags.ES /> },
  { value: 'lk', label: 'Sri Lanka', icon: <countryFlags.LK /> },
  { value: 'sd', label: 'Sudan', icon: <countryFlags.SD /> },
  { value: 'sr', label: 'Suriname', icon: <countryFlags.SR /> },
  { value: 'sj', label: 'Svalbard and Jan Mayen', icon: <countryFlags.SJ /> },
  { value: 'se', label: 'Sweden', icon: <countryFlags.SE /> },
  { value: 'ch', label: 'Switzerland', icon: <countryFlags.CH /> },
  { value: 'sy', label: 'Syrian Arab Republic', icon: <countryFlags.SY /> },
  { value: 'tw', label: 'Taiwan', icon: <countryFlags.TW /> },
  { value: 'tj', label: 'Tajikistan', icon: <countryFlags.TJ /> },
  {
    value: 'tz',
    label: 'Tanzania',
    icon: <countryFlags.TZ />,
  },
  { value: 'th', label: 'Thailand', icon: <countryFlags.TH /> },
  { value: 'tl', label: 'Timor-Leste', icon: <countryFlags.TL /> },
  { value: 'tg', label: 'Togo', icon: <countryFlags.TG /> },
  { value: 'tk', label: 'Tokelau', icon: <countryFlags.TK /> },
  { value: 'to', label: 'Tonga', icon: <countryFlags.TO /> },
  { value: 'tt', label: 'Trinidad and Tobago', icon: <countryFlags.TT /> },
  { value: 'tn', label: 'Tunisia', icon: <countryFlags.TN /> },
  { value: 'tr', label: 'Turkey', icon: <countryFlags.TR /> },
  { value: 'tm', label: 'Turkmenistan', icon: <countryFlags.TM /> },
  {
    value: 'tc',
    label: 'Turks and Caicos Islands',
    icon: <countryFlags.TC />,
  },
  { value: 'tv', label: 'Tuvalu', icon: <countryFlags.TV /> },
  { value: 'ug', label: 'Uganda', icon: <countryFlags.UG /> },
  { value: 'ua', label: 'Ukraine', icon: <countryFlags.UA /> },
  {
    value: 'ae',
    label: 'United Arab Emirates',
    icon: <countryFlags.AE />,
  },
  {
    value: 'gb',
    label: 'United Kingdom',
    icon: <countryFlags.GB />,
  },
  {
    value: 'um',
    label: 'United States Minor Outlying Islands',
    icon: <countryFlags.UM />,
  },
  {
    value: 'us',
    label: 'United States of America',
    icon: <countryFlags.US />,
  },
  { value: 'uy', label: 'Uruguay', icon: <countryFlags.UY /> },
  { value: 'uz', label: 'Uzbekistan', icon: <countryFlags.UZ /> },
  { value: 'vu', label: 'Vanuatu', icon: <countryFlags.VU /> },
  {
    value: 've',
    label: 'Venezuela',
    icon: <countryFlags.VE />,
  },
  { value: 'vn', label: 'Viet Nam', icon: <countryFlags.VN /> },
  {
    value: 'vg',
    label: 'Virgin Islands',
    icon: <countryFlags.VG />,
  },
  { value: 'vi', label: 'Virgin Islands', icon: <countryFlags.VI /> },
  { value: 'wf', label: 'Wallis and Futuna', icon: <countryFlags.WF /> },
  { value: 'eh', label: 'Western Sahara', icon: <countryFlags.EH /> },
  { value: 'ye', label: 'Yemen', icon: <countryFlags.YE /> },
  { value: 'zm', label: 'Zambia', icon: <countryFlags.ZM /> },
  { value: 'zw', label: 'Zimbabwe', icon: <countryFlags.ZW /> },
  { value: 'ax', label: 'Åland Islands', icon: <countryFlags.AX /> },
]

export default countryList
